import React from 'react'
import TablaPasajeros from './Pasajeros/TablaPasajeros'

export default function Pasajeros() {
    return (
        <TablaPasajeros/>
    )
}
